module.exports = __webpack_public_path__ + "img/another-day-at-the-lab.35f0d1f5.png";